export const kpiSalesHeader = [
  {
    group: 'Data',
    columns: [
      {
        name: 'Execução',
        id: 'data-execucao-id',
        show: false
      }
    ]
  },
  {
    group: 'CD/Loja',
    columns: [
      {
        name: 'Código',
        id: 'cd-loja-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'cd-loja-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Gerente',
    columns: [
      {
        name: 'Categoria',
        id: 'gerente-categoria-id',
        show: false
      },
      {
        name: 'Produto',
        id: 'gerente-produto-id',
        show: false
      }
    ]
  },
  // {
  //   group: 'Mundo',
  //   columns: [
  //     {
  //       name: 'Código',
  //       id: 'mundo-codigo-id',
  //       show: false
  //     },
  //     {
  //       name: 'Nome',
  //       id: 'mundo-nome-id',
  //       show: false
  //     }
  //   ]
  // },
  {
    group: 'Categoria Compacta',
    columns: [
      {
        name: 'Código',
        id: 'categoria-compacta-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'categoria-compacta-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Categoria',
    columns: [
      {
        name: 'Código',
        id: 'categoria-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'categoria-nome-id',
        show: false
      }
    ]
  },
  // {
  //   group: 'Sub Categoia',
  //   columns: [
  //     {
  //       name: 'Código',
  //       id: 'subcategoria-codigo-id',
  //       show: false
  //     },
  //     {
  //       name: 'Nome',
  //       id: 'subcategoria-nome-id',
  //       show: false
  //     }
  //   ]
  // },
  {
    group: 'Status',
    columns: [
      {
        name: 'Nome',
        id: 'status-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Curva',
    columns: [
      {
        name: 'Nome',
        id: 'curva-abc-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'Código',
        id: 'fornecedor-codigo-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'fornecedor-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Empresa',
    columns: [
      {
        name: 'Código',
        id: 'empresa-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'empresa-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Venda',
    columns: [
      {
        name: 'Bruta (R$)',
        id: 'venda-bruta-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Líquida (R$)',
        id: 'venda-liquida-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Orçada Liq (R$)',
        id: 'venda-orcada-liq-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Realizado Liq R$ (%)',
        id: 'venda-realizado-liq-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Bruta (BTLeo)',
        id: 'venda-bruta-btleo-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Líquida (BTLeo)',
        id: 'venda-liquida-btleo-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Orçada (Liq BTLeo)',
        id: 'venda-orcada-btleo-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Realizado BTLeo (%)',
        id: 'venda-realizado-btleo-id',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Margem',
    columns: [
      {
        name: 'Líquida (R$)',
        id: 'margem-liquida-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Orçada (R$)',
        id: 'margem-orcada-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Atual (%)',
        id: 'margem-atual-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Orçada (%)',
        id: 'margem-orcada-porc-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Dif P.P.',
        id: 'margem-dif-id',
        show: true,
        isNumeric: true
      }
    ]
  }
]
